"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = Link;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Link.css"));
var _clsx = require("clsx");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable react/jsx-no-target-blank */

/***** STYLES *****/

/***** COMPONENT *****/
function Link(props) {
  const {
    children,
    onClick,
    url,
    target = 'self',
    title = '',
    rel,
    theme = 'black',
    size = '16'
  } = props;
  return /*#__PURE__*/React.createElement("a", {
    target: `_${target}`,
    title: title,
    onClick: event => {
      if (onClick) {
        onClick(event);
      }
    },
    href: url,
    className: (0, _clsx.clsx)(styles['element'], theme === 'primary' && styles['primary'], size === '14' && styles['size-s'], size === '28' && styles['size-l']),
    rel: rel
  }, children);
}